module.exports = __webpack_public_path__ + "img/组件 93.7394f0b6.png";